var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame140(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#2D53DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.0001L9 21.0001V25.0001L13 25.0001L21 17.0001M17 13.0001L19.8686 10.1315L19.8704 10.1298C20.2652 9.73488 20.463 9.53709 20.691 9.46301C20.8919 9.39775 21.1082 9.39775 21.3091 9.46301C21.5369 9.53704 21.7345 9.7346 22.1288 10.1289L23.8686 11.8687C24.2646 12.2647 24.4627 12.4628 24.5369 12.6912C24.6022 12.892 24.6021 13.1084 24.5369 13.3092C24.4628 13.5374 24.265 13.7352 23.8695 14.1306L23.8686 14.1315L21 17.0001M17 13.0001L21 17.0001",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame140);
export default __webpack_public_path__ + "static/media/Frame-140.cf7590d024f7f41677d712f4b3d91c8e.svg";
export { ForwardRef as ReactComponent };